/**
 *
 * OffersLaneComponent
 *
 */

import {
  abTestVersions,
  AbTest,
  PNP_BASE_OFFERS,
  PNP_UPGRADED_OFFERS,
  STEPPER,
} from "root/libs/ui-containers/src/lib/AbTest";
import React from "react";
import PropTypes from "prop-types";
import scrollToComponent from "react-scroll-to-component";
import { DhlText } from "@dhl-official/react-library";
import { Sizes } from "@dhl-official/stencil-library";
import {
  SS,
  domain,
  COMMON,
  UTF_EVENT_PAGE_NAMES,
  UTF_EVENT_CONTENT_NAMES,
  UTF_EVENT_TYPES,
  UTF_EVENT_INTERACTIONS,
  UTF_EVENT_CONTENT_POSITION,
  UTF_PRODUCT_CARD_VARIATIONS,
  UTF_EVENT_CONVERSION_NAMES,
  UTF_EVENT_CONVERSION_TYPES,
  UTF_EVENT_CONVERSION_DETAIL,
} from "root/libs/constants/src";
import { CountrySettings, CanaryVersions } from "root/libs/ui-containers/src";
import memoize from "lodash/memoize";
import ModalExpress from "one-time-shipment/src/components/Modals/ModalExpress";
import ModalFreightP2P from "one-time-shipment/src/components/Modals/ModalFreightP2P/container";
import { injectIntl } from "react-intl";
import {
  IntlPropType,
  createShareCode,
  createShareUrl,
  trackEngagementAndProductInteraction,
  getUtfAddOnString,
  sortMultiBUOffersByPurchaseMethod,
  getCheapestOffersPerPurchaseMethod,
} from "root/libs/core-libs/src";
import ResponsiveRender from "one-time-shipment/src/components/Layout/ResponsiveRender";
import TeaserOverlay from "one-time-shipment/src/components/Teaser/TeaserOverlay";
import { ModalError, GridContainer, Icon } from "root/libs/ui-components/src";
import PrintButton from "one-time-shipment/src/components/Buttons/PrintButton";
import ShareButton from "one-time-shipment/src/components/Buttons/ShareButton";
import SaveShipmentButton from "one-time-shipment/src/components/Buttons/SaveShipmentButton";
import OfferLaneDatePicker from "one-time-shipment/src/components/OfferLaneDatePicker";
import OfferCard from "one-time-shipment/src/components/Offers/OfferCard";
import WCCOffersCardWrapper from "one-time-shipment/src/components/Offers/WCCOffersCardWrapper";
import WCCMultiBUOfferCardWrapper from "one-time-shipment/src/components/Offers/WCCMultiBUOfferCardWrapper";
import TargetedServiceCard from "one-time-shipment/src/components/Offers/TargetedServiceCard";
import DomesticSolutionCard from "one-time-shipment/src/components/Offers/DomesticSolutionCard";
import EmptyOffers from "one-time-shipment/src/components/Offers/EmptyOffers";
import OfferSort from "one-time-shipment/src/components/Offers/OfferSort/container";
import ModalSuccess from "one-time-shipment/src/components/Modals/ModalSuccess";
import BookingNotAllowed from "one-time-shipment/src/components/Modals/BookingNotAllowed/container";
import { selectTrackingKey } from "one-time-shipment/src/containers/Tracking/selectors";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import CopyQuoteLinkButton from "one-time-shipment/src/components/Buttons/CopyQuoteLinkButton";
import { SEGMENT_TYPES } from "one-time-shipment/src/containers/SpotShipmentPage/constants";

import arrowBack from "@dhl-official/icons/arrow-back.svg";
import { isScrollEnabled } from "one-time-shipment/src/helpers/isScrollDisabled";
import {
  OfferLaneWrapper,
  OfferFilterWrapper,
  OfferWrapper,
  StyledHeadline,
  StyledHeadlineWrapper,
  StyledDivForPDFPrinting,
  StyledText,
  ShippingDateWrapper,
  ShippingDateSelectWrapper,
  Disclaimer,
  VisitLaterActionsWrapper,
  PrintDisclaimerWrapper,
  SaveShipmentButtonWrapper,
  BackButtonWrapper,
  OffersSectionWrapper,
  CustomBackButton,
  StyledIconWrapper,
} from "./styled";

const { withCountry } = CountrySettings;

const {
  constants: { TYPES_OF_CANARY_VERSIONS },
} = CanaryVersions;

const COPY_ID_PREFIX = "OffersLaneComponent";

const COPY_ID_PREFIX_NAVIGATION = "NavigationButton";

const multiBU = "MULTI_BU_ONLY";
const singleBU = "SINGLE_BU_ONLY";

class OffersLaneComponent extends React.PureComponent {
  buildShareableObject = memoize(
    ({
      spotShipmentPage,
      shipmentLaneInitialSet,
      documentsOptionValue,
      originDestinationFlipped,
      tradeLaneInitialSet,
      sortOffersBy,
      selectedUnitSystem,
    }) => ({
      spotShipmentPage: {
        ...spotShipmentPage,
      },
      shipmentLane: {
        selectedUnitSystem,
        initialSet: shipmentLaneInitialSet,
      },
      tradeLane: {
        documentsOptionValue,
        originDestinationFlipped,
        initialSet: tradeLaneInitialSet,
      },
      getQuote: {
        sortOffersBy,
      },
    })
  );

  static propTypes = {
    /** Translations library */
    intl: IntlPropType.isRequired,
    offers: PropTypes.array.isRequired,
    isOffersLaneVisible: PropTypes.bool.isRequired,
    isWaitingForResponse: PropTypes.bool.isRequired,
    haveTheBackendsErrors: PropTypes.bool,
    isModalErrorVisible: PropTypes.bool,
    shippingDate: PropTypes.string.isRequired,
    isShippingDateVisible: PropTypes.bool.isRequired,
    updateShippingDate: PropTypes.func.isRequired,
    trackEvent: PropTypes.func.isRequired,
    spotShipmentTabReference: PropTypes.object,
    toggleModalError: PropTypes.func,
    toggleModalSuccess: PropTypes.func,
    hasBackButtonClicked: PropTypes.func,
    retrySubmitAction: PropTypes.func,
    hasNetworkError: PropTypes.bool,
    reference: PropTypes.object,
    /** Boolean indicating the display of the Mobile Express PTP modal */
    isModalExpressVisible: PropTypes.bool,
    /** Boolean indicating the display of the Booking not allowed PTP modal */
    isModalBookingNotAllowedVisible: PropTypes.bool,
    /** Boolean indicating the display of the Freight P2P modal */
    isModalFreightP2PVisible: PropTypes.bool,
    /** Boolean indicating the display of the Success modal */
    isModalSuccessVisible: PropTypes.bool,
    /** Function to hand over for controlling the display of the Mobile Express PTP modal */
    toggleModalExpress: PropTypes.func,
    /** Function to hand over for controlling the display of the Booking not allowed PTP modal */
    toggleBookingNotAllowedModal: PropTypes.func,
    /** Function to hand over for controlling the display of the Freight P2P modal */
    toggleFreightP2PModal: PropTypes.func,
    /** Function to handle changes of input fields */
    onFreightP2PModalInformationChange: PropTypes.func,
    /** Object containing the current validity status of all form fields from Redux */
    isFormValid: PropTypes.bool.isRequired,
    /** Dispatcher function to validate the form fields */
    validateFreightP2PModalFormFields: PropTypes.func,
    /** Called during onSubmit handler to dispatch http request to the BE service */
    getFreightP2PModalRequestSent: PropTypes.func.isRequired,
    isWaitingForFreightModalResponse: PropTypes.bool.isRequired,
    enableTeaserOverlayFeature: PropTypes.bool,
    toggleRegularShipmentTeaser: PropTypes.func,
    shouldScroll: PropTypes.bool,
    resetScrolling: PropTypes.func,
    tradeLaneInitialSet: PropTypes.object,
    destinationField: PropTypes.object,
    shipmentLaneInitialSet: PropTypes.object,
    documentsOptionValue: PropTypes.object,
    spotShipmentPage: PropTypes.object,
    originDestinationFlipped: PropTypes.bool,
    isBusiness: PropTypes.bool,
    showCurrencyIsoCodeForPrices: PropTypes.bool,
    sortOffersBy: PropTypes.string,
    selectedUnitSystem: PropTypes.string,
    backToShipmentLaneReference: PropTypes.object,
    country: PropTypes.string.isRequired,
    language: PropTypes.string.isRequired,
    isSortOffersByVisible: PropTypes.bool.isRequired,
    pageName: PropTypes.string.isRequired,
    experience: PropTypes.string,
    canaryEnabled: PropTypes.bool,
    canaryVersion: PropTypes.string,
    aggregatedOfferViewMode: PropTypes.shape({
      private: PropTypes.string,
      business: PropTypes.string,
    }),
    abTestRunning: PropTypes.bool,
    abTestVersion: PropTypes.string,
  };

  static defaultProps = {
    spotShipmentTabReference: {},
    haveTheBackendsErrors: false,
    isModalErrorVisible: false,
    validateFreightP2PModalFormFields: () => {},
    hasNetworkError: false,
    toggleModalError: () => {},
    toggleModalSuccess: () => {},
    retrySubmitAction: () => {},
    reference: React.createRef(),
    isModalExpressVisible: false,
    isModalBookingNotAllowedVisible: false,
    isModalFreightP2PVisible: false,
    toggleModalExpress: () => {},
    toggleBookingNotAllowedModal: () => {},
    toggleFreightP2PModal: () => {},
    onFreightP2PModalInformationChange: () => {},
    enableTeaserOverlayFeature: false,
    toggleRegularShipmentTeaser: () => {},
    shouldScroll: false,
    resetScrolling: () => {},
    tradeLaneInitialSet: {},
    destinationField: {},
    shipmentLaneInitialSet: {},
    documentsOptionValue: {
      private: false,
      business: false,
    },
    spotShipmentPage: {},
    originDestinationFlipped: false,
    isBusiness: false,
    isModalSuccessVisible: false,
    showCurrencyIsoCodeForPrices: false,
    selectedUnitSystem: "",
    backToShipmentLaneReference: React.createRef(),
    experience: "",
    aggregatedOfferViewMode: {
      private: "SINGLE_BU_ONLY",
      business: "MULTI_BU_ONLY",
    },
    abTestRunning: false,
  };

  constructor(props) {
    super(props);
    const trackingKeySelector = selectTrackingKey;
    this.shipmentDateChangedTrackingKeyPath = trackingKeySelector(
      "spotShipment.interactions.offersTriggers.shipmentDateChanged"
    );
    this.downloadQuotesClickedTrackingKeyPath = trackingKeySelector(
      "spotShipment.interactions.offersTriggers.downloadQuotesClicked"
    );
    this.shareQuotesClickedTrackingKeyPath = trackingKeySelector(
      "spotShipment.interactions.offersTriggers.shareQuotesClicked"
    );
    this.shareQuotesFallbackClickedTrackingKeyPath = trackingKeySelector(
      "spotShipment.interactions.offersTriggers.shareQuotesFallbackClicked"
    );
    this.freightP2PModalCloseButtonTrackingKeyPath = trackingKeySelector(
      "spotShipment.interactions.clickedOnFreightP2PModalCloseButton"
    );
    this.frequentShipmentLink = trackingKeySelector(
      "spotShipment.interactions.clickedOnFrequentShipmentLink"
    );
    this.ModalExpressWithCountry = withCountry(ModalExpress);
    this.ModalFreightP2PWithCountry = withCountry(ModalFreightP2P);

    this.experience = props.experience;

    this.selectedSegment = props.isBusiness
      ? SEGMENT_TYPES.business
      : SEGMENT_TYPES.private;

    this.scrollTimeoutId = null;

    this.state = {
      modalFreightP2POfferData: {
        quotationId: "",
        amount: "",
        tax: "WITHOUT",
        currencyCode: "",
        deliveryOption: "",
        deliveryType: "COMMITTED",
        originCountry: "",
        pickUpDate: "",
        destinationCountry: "",
        deliveryDate: "",
      },
    };
  }

  // The component was mounted several times instead of updating
  componentDidUpdate = () => {
    const {
      shouldScroll,
      resetScrolling,
      reference,
      isOffersLaneVisible,
      trackEvent,
      pageName,
      isWaitingForResponse,
      isBusiness,
    } = this.props;
    const { PRODUCT_LANE } = UTF_EVENT_PAGE_NAMES;

    this.selectedSegment = isBusiness
      ? SEGMENT_TYPES.business
      : SEGMENT_TYPES.private;
    if (isOffersLaneVisible) {
      if (!isWaitingForResponse) {
        trackEngagementAndProductInteraction({
          funnel: {
            name: pageName,
            type: UTF_EVENT_CONTENT_NAMES.CUSTOMER_JOURNEY,
            step: PRODUCT_LANE,
            progress: UTF_EVENT_INTERACTIONS.LOAD,
          },
          content: {
            context: this.selectedSegment,
            attributes: {
              layoutVersion: this.getLayoutVersionForTracking(),
            },
          },
          products: this.prepareOffersForTracking(),
        });
      }
      trackEvent({ quoteLaneRendered: true });
    }

    if (shouldScroll && isScrollEnabled()) {
      // Clear any existing timeout to prevent multiple scroll attempts
      if (this.scrollTimeoutId) {
        clearTimeout(this.scrollTimeoutId);
      }
      this.scrollTimeoutId = setTimeout(() => {
        scrollToComponent(reference.current, {
          align: "top",
        });
        resetScrolling();
      }, 0);
    }
  };

  componentWillUnmount() {
    if (this.scrollTimeoutId) {
      clearTimeout(this.scrollTimeoutId);
    }
  }

  areOffersEmpty = () => {
    const { offers } = this.props;
    return !offers || offers.length === 0;
  };

  getOfferById = (offerId, offers) => {
    return offers.find((obj) => obj.id === offerId);
  };

  calculateDiscountPercentage = (price, priceWithoutDiscount) => {
    if (!priceWithoutDiscount || !priceWithoutDiscount.amount) {
      return null; // Indicate that there is no discount available
    }

    if (!price || !price.amount) {
      return null; // Handle cases where the price is invalid
    }

    const discountAmount = priceWithoutDiscount.amount - price.amount;
    if (discountAmount <= 0) {
      return 0; // No discount if the discount amount is zero or negative
    }

    const discountPercentage =
      (discountAmount / priceWithoutDiscount.amount) * 100;
    return discountPercentage;
  };

  offersForTracking = (singleOffer) => {
    const { canaryEnabled, canaryVersion } = this.props;
    const shippingModesString = getUtfAddOnString(singleOffer.addOns);

    const netPrice = singleOffer?.price?.billingTaxAmount
      ? singleOffer?.price?.billingAmount - singleOffer?.price?.billingTaxAmount
      : singleOffer?.price?.billingAmount;

    const strikenPrice =
      canaryEnabled && canaryVersion === TYPES_OF_CANARY_VERSIONS.strikethrough
        ? singleOffer?.priceWithoutDiscount?.billingAmount
        : null;

    const discountPercentage = this.calculateDiscountPercentage(
      singleOffer?.price,
      singleOffer?.priceWithoutDiscount
    );

    return {
      id: singleOffer.id,
      key: singleOffer.key,
      businessUnit: singleOffer.businessUnit,
      price: singleOffer?.price?.billingAmount,
      currencyCode: singleOffer?.price?.billingCurrencyCode,
      shippingModes: shippingModesString,
      netPrice,
      ...(strikenPrice !== null && { strikenPrice }),
      ...(discountPercentage !== null && {
        discountPercentage,
      }),
    };
  };

  prepareOffersForTracking = () => {
    const { offers } = this.props;
    let returnThisArray = [];
    if (this.isWCCMultiBUAggregatedFn()) {
      const cheapestOffersPerPurchaseMethod = getCheapestOffersPerPurchaseMethod(
        offers
      );
      returnThisArray = [
        ...cheapestOffersPerPurchaseMethod,
        ...offers.filter((offer) => offer.purchaseMethod === undefined),
      ].map(this.offersForTracking);
    } else if (this.isWCCSingleBUAggregatedFn()) {
      returnThisArray = getCheapestOffersPerPurchaseMethod(offers).map(
        this.offersForTracking
      );
    } else {
      returnThisArray = offers.map(this.offersForTracking);
    }

    return returnThisArray;
  };

  closeFreightP2PModal = () => {
    const { toggleFreightP2PModal, trackEvent } = this.props;

    trackEvent({ clickedOnFreightP2PModalCloseButton: true });

    toggleFreightP2PModal();
  };

  toggleFreightP2PModal = (freightOffer) => {
    const { toggleFreightP2PModal, trackEvent } = this.props;

    this.setState({
      modalFreightP2POfferData: freightOffer.freightModal,
    });

    trackEvent({
      freightP2PModalQuotationId: freightOffer.freightModal.quotationId,
    });

    toggleFreightP2PModal(freightOffer.freightModal.quotationId);
  };

  onFreightP2PModalInformationChange = (eventAndInputValues) => {
    const { onFreightP2PModalInformationChange } = this.props;

    const { inputValue } = eventAndInputValues;

    onFreightP2PModalInformationChange({ ...inputValue });
  };

  getCopy = (id, values, prefix = COPY_ID_PREFIX) => {
    const { intl } = this.props;
    let messageId = `${prefix}.${id}`;

    if (this.experience && this.experience !== "") {
      const experienceMessageId = `${messageId}_${this.experience}`;
      if (intl.messages[experienceMessageId]) {
        messageId = experienceMessageId;
      }
    }

    return intl.messages[messageId]
      ? intl.formatMessage({ id: messageId }, values)
      : messageId;
  };

  onSuccessSaveHandler = (savedQuoteSuccess) => {
    this.setState({
      // eslint-disable-next-line react/no-unused-state
      hasSavedQuote: savedQuoteSuccess,
    });
  };

  getLayoutVersionForTracking = () => {
    const { LEGACY, SINGLE_BU, MULTI_BU } = UTF_PRODUCT_CARD_VARIATIONS;

    if (this.isWCCSingleBUAggregatedFn()) return SINGLE_BU;
    if (this.isWCCMultiBUAggregatedFn()) return MULTI_BU;
    return LEGACY;
  };

  isWCCMultiBUAggregatedFn = () => {
    const { isBusiness, aggregatedOfferViewMode } = this.props;

    return (
      (isBusiness && aggregatedOfferViewMode.business === multiBU) ||
      (!isBusiness && aggregatedOfferViewMode.private === multiBU)
    );
  };

  isWCCSingleBUAggregatedFn = () => {
    const { isBusiness, aggregatedOfferViewMode } = this.props;
    return (
      (isBusiness && aggregatedOfferViewMode.business === singleBU) ||
      (!isBusiness && aggregatedOfferViewMode.private === singleBU)
    );
  };

  /**
   * @param {{fallback?: React.ReactNode, index: number, offer: object, targetVersion: string | string[]}} props
   */
  renderAbTestOfferCard = ({ index, fallback, offer, targetVersion }) => {
    const {
      canaryEnabled,
      canaryVersion,
      intl,
      isBusiness,
      offers,
      showCurrencyIsoCodeForPrices,
      toggleBookingNotAllowedModal,
      toggleModalExpress,
      trackEvent,
      destinationField,
    } = this.props;

    return (
      <AbTest fallback={fallback} targetVersion={targetVersion}>
        {({ currentVersion, running }) => (
          <OfferCard
            abTestRunning={running}
            abTestVersion={currentVersion}
            canaryEnabled={canaryEnabled}
            canaryVersion={canaryVersion}
            index={index}
            indexLength={offers.length}
            intl={intl}
            isBusiness={isBusiness}
            offer={offer}
            destinationField={destinationField}
            showCurrencyIsoCodeForPrices={showCurrencyIsoCodeForPrices}
            toggleBookingNotAllowedModal={toggleBookingNotAllowedModal}
            toggleFreightP2PModal={this.toggleFreightP2PModal}
            toggleModalExpress={toggleModalExpress}
            trackEvent={trackEvent}
          />
        )}
      </AbTest>
    );
  };

  renderOffers = () => {
    const {
      canaryEnabled,
      canaryVersion,
      intl,
      isBusiness,
      offers,
      showCurrencyIsoCodeForPrices,
      toggleBookingNotAllowedModal,
      toggleModalExpress,
      trackEvent,
      destinationField,
    } = this.props;

    const isWCCMultiBUAggregated = this.isWCCMultiBUAggregatedFn();
    const isWCCSingleBUAggregated = this.isWCCSingleBUAggregatedFn();

    const wccMultiBUOffersSorted = isWCCMultiBUAggregated
      ? sortMultiBUOffersByPurchaseMethod(offers)
      : null;

    const utfTargetServiceCard = {
      conversion: {
        name: UTF_EVENT_CONVERSION_NAMES.CONTINUE_TO_FS,
        type: UTF_EVENT_CONVERSION_TYPES.HANDOVER,
        detail: UTF_EVENT_CONVERSION_DETAIL.TARGETED_SERVICE_CARD,
      },
      content: {
        name: UTF_EVENT_CONTENT_NAMES.FS_GET_IN_CONTACT,
        type: UTF_EVENT_TYPES.BUTTON,
        interaction: UTF_EVENT_INTERACTIONS.CLICK,
        position: UTF_EVENT_CONTENT_POSITION.PRODUCT_LANE,
        context: isBusiness ? SEGMENT_TYPES.business : SEGMENT_TYPES.private,
      },
    };

    const utfDomesticSolutionCard = {
      conversion: {
        name: UTF_EVENT_CONVERSION_NAMES.CONTACT_WITH_EXPERT,
        type: UTF_EVENT_CONVERSION_TYPES.HANDOVER,
        detail: UTF_EVENT_CONVERSION_DETAIL.DOMESTIC_TRANSPORT_SOLUTION_CARD,
      },
      content: {
        name: UTF_EVENT_CONTENT_NAMES.DOMESTIC_GET_IN_CONTACT,
        type: UTF_EVENT_TYPES.BUTTON,
        interaction: UTF_EVENT_INTERACTIONS.CLICK,
        position: UTF_EVENT_CONTENT_POSITION.PRODUCT_LANE,
        context: isBusiness ? SEGMENT_TYPES.business : SEGMENT_TYPES.private,
      },
    };

    if (isWCCMultiBUAggregated) {
      return wccMultiBUOffersSorted.map((obj) => {
        if (!obj.offers.length) {
          return null;
        }

        return (
          <OfferWrapper key={obj.method} className="grid-maxWidth">
            {obj.method === "TARGET_SERVICE" ? (
              obj.offers.map((offer, index) => (
                <React.Fragment key={`${offer.key}-${offer.id}`}>
                  {offer.key === COMMON.TARGET_SERVICE_CARD_KEY ? (
                    <TargetedServiceCard
                      intl={intl}
                      trackEvent={trackEvent}
                      contentKey={offer.specialOffers}
                      utfDataObject={utfTargetServiceCard}
                      cid={COMMON.TARGET_SERVICE_CARD_CID}
                    />
                  ) : (
                    this.renderAbTestOfferCard({
                      targetVersion: abTestVersions.control,
                      index,
                      offer,
                    })
                  )}
                </React.Fragment>
              ))
            ) : (
              <WCCMultiBUOfferCardWrapper
                intl={intl}
                offers={obj.offers}
                showCurrencyIsoCodeForPrices={showCurrencyIsoCodeForPrices}
                purchaseMethod={obj.method}
                trackEvent={trackEvent}
                toggleModalExpress={toggleModalExpress}
                toggleBookingNotAllowedModal={toggleBookingNotAllowedModal}
                toggleFreightP2PModal={this.toggleFreightP2PModal}
                isBusiness={isBusiness}
                indexLength={offers.length}
                canaryEnabled={canaryEnabled}
                canaryVersion={canaryVersion}
                destinationField={destinationField}
                isHighlighted={obj.isHighlighted}
              />
            )}
          </OfferWrapper>
        );
      });
    }
    if (isWCCSingleBUAggregated) {
      return (
        <OfferWrapper className="grid-maxWidth">
          <WCCOffersCardWrapper
            intl={intl}
            offers={offers}
            showCurrencyIsoCodeForPrices={showCurrencyIsoCodeForPrices}
            trackEvent={trackEvent}
            toggleModalExpress={toggleModalExpress}
            toggleBookingNotAllowedModal={toggleBookingNotAllowedModal}
            toggleFreightP2PModal={this.toggleFreightP2PModal}
            isBusiness={isBusiness}
            index={0}
            indexLength={offers.length}
            canaryEnabled={canaryEnabled}
            canaryVersion={canaryVersion}
          />
        </OfferWrapper>
      );
    }

    return offers.map((offer, index) => {
      const key = `${offer.key}-${offer.id}`;

      if (offer.key === COMMON.TARGET_SERVICE_CARD_KEY) {
        return (
          <OfferWrapper key={key} className="grid-maxWidth">
            <TargetedServiceCard
              intl={intl}
              trackEvent={trackEvent}
              contentKey={offer.specialOffers}
              utfDataObject={utfTargetServiceCard}
              cid={COMMON.TARGET_SERVICE_CARD_CID}
            />
          </OfferWrapper>
        );
      }

      if (offer.key === COMMON.DOMESTIC_TRANSPORT_SOLUTION_CARD_KEY) {
        return (
          <OfferWrapper key={key} className="grid-maxWidth">
            <DomesticSolutionCard
              intl={intl}
              trackEvent={trackEvent}
              contentKey={offer.specialOffers}
              utfDataObject={utfDomesticSolutionCard}
            />
          </OfferWrapper>
        );
      }

      return (
        <OfferWrapper key={key} className="grid-maxWidth">
          {this.renderAbTestOfferCard({
            targetVersion: [
              abTestVersions.control,
              abTestVersions.strikethrough,
              abTestVersions[PNP_BASE_OFFERS],
              abTestVersions[PNP_UPGRADED_OFFERS],
            ],
            fallback: (
              <OfferCard
                intl={intl}
                offer={offer}
                showCurrencyIsoCodeForPrices={showCurrencyIsoCodeForPrices}
                trackEvent={trackEvent}
                toggleModalExpress={toggleModalExpress}
                toggleBookingNotAllowedModal={toggleBookingNotAllowedModal}
                toggleFreightP2PModal={this.toggleFreightP2PModal}
                isBusiness={isBusiness}
                destinationField={destinationField}
                index={index}
                indexLength={offers.length}
                canaryEnabled={canaryEnabled}
                canaryVersion={canaryVersion}
              />
            ),
            index,
            offer,
          })}
        </OfferWrapper>
      );
    });
  };

  render() {
    const {
      intl,
      isOffersLaneVisible,
      haveTheBackendsErrors,
      isModalErrorVisible,
      shippingDate,
      isShippingDateVisible,
      trackEvent,
      spotShipmentTabReference,
      toggleModalError,
      toggleModalSuccess,
      isWaitingForResponse,
      hasNetworkError,
      retrySubmitAction,
      reference,
      isModalExpressVisible,
      isModalBookingNotAllowedVisible,
      isModalFreightP2PVisible,
      toggleModalExpress,
      toggleBookingNotAllowedModal,
      enableTeaserOverlayFeature,
      toggleRegularShipmentTeaser,
      tradeLaneInitialSet,
      shipmentLaneInitialSet,
      spotShipmentPage,
      documentsOptionValue,
      originDestinationFlipped,
      isBusiness,
      isFormValid,
      validateFreightP2PModalFormFields,
      getFreightP2PModalRequestSent,
      isWaitingForFreightModalResponse,
      isModalSuccessVisible,
      showCurrencyIsoCodeForPrices,
      sortOffersBy,
      selectedUnitSystem,
      country,
      backToShipmentLaneReference,
      isSortOffersByVisible,
      updateShippingDate,
      language,
      hasBackButtonClicked,
      abTestRunning,
      abTestVersion,
    } = this.props;

    const { modalFreightP2POfferData } = this.state;

    const isLoadingIndicatorVisible =
      isWaitingForResponse && isOffersLaneVisible;
    const shareDataObject = this.buildShareableObject({
      spotShipmentPage,
      shipmentLaneInitialSet,
      documentsOptionValue,
      originDestinationFlipped,
      tradeLaneInitialSet,
      sortOffersBy,
      selectedUnitSystem,
    });

    const shareCode = createShareCode(shareDataObject);
    const shareUrl = createShareUrl(shareCode);

    const stepperEnabled =
      abTestRunning && abTestVersion === abTestVersions[STEPPER];

    return (
      <React.Fragment>
        {!isOffersLaneVisible || hasNetworkError ? null : (
          <React.Fragment>
            <OffersSectionWrapper
              ref={reference}
              stepperEnabled={stepperEnabled}
            >
              <StyledDivForPDFPrinting />
              <StyledHeadlineWrapper
                stepperEnabled={stepperEnabled}
                className="grid-maxWidthInner"
              >
                <React.Fragment>
                  <StyledHeadline
                    priority={2}
                    headlineDisplayType="h"
                    centerInDesktop
                    weight="800"
                  >
                    {this.getCopy(
                      stepperEnabled ? "headline_business" : "headline"
                    )}
                  </StyledHeadline>
                  {!this.areOffersEmpty() && (
                    <StyledText isParagraph>
                      {this.getCopy("subheadline")}
                    </StyledText>
                  )}
                </React.Fragment>
                <span className="visually-hidden" aria-live="assertive">
                  {this.getCopy("screenReaderLabel_messageOnAppear")}
                </span>
              </StyledHeadlineWrapper>
              <div
                role="feed"
                aria-busy={isLoadingIndicatorVisible ? "true" : "false"}
              >
                {isLoadingIndicatorVisible && (
                  <React.Fragment>
                    <GridContainer
                      dimension="biDimensional"
                      addMaxWidth
                      halfGutterPadding
                      stepperEnabled={stepperEnabled}
                    >
                      <ShippingDateWrapper
                        gridColumn="2 / span 4"
                        isLoading={stepperEnabled}
                      >
                        <DhlText weight={200}>
                          <Skeleton width={100} />
                        </DhlText>

                        <ShippingDateSelectWrapper>
                          <Skeleton width={380} height={56} />
                        </ShippingDateSelectWrapper>
                      </ShippingDateWrapper>
                    </GridContainer>

                    <OfferWrapper
                      className="grid-maxWidth"
                      stepperEnabled={stepperEnabled}
                    >
                      <Skeleton height={167} />
                    </OfferWrapper>
                  </React.Fragment>
                )}

                {!isLoadingIndicatorVisible && (
                  <OfferLaneWrapper role="article">
                    {!this.areOffersEmpty() && (
                      <React.Fragment>
                        <OfferFilterWrapper
                          stepperEnabled={stepperEnabled}
                          dimension="biDimensional"
                          addMaxWidth
                        >
                          {isShippingDateVisible && (
                            <ShippingDateWrapper
                              gridColumn="2 / span 3"
                              spanTablet="5"
                            >
                              <ShippingDateSelectWrapper>
                                <OfferLaneDatePicker
                                  getCopy={this.getCopy}
                                  language={language}
                                  shippingDate={shippingDate}
                                  trackEvent={trackEvent}
                                  updateShippingDate={updateShippingDate}
                                />
                              </ShippingDateSelectWrapper>
                            </ShippingDateWrapper>
                          )}
                          {isSortOffersByVisible && (
                            <OfferSort
                              intl={intl}
                              sortOffersBy={sortOffersBy}
                              segment={this.selectedSegment}
                            />
                          )}
                          <SaveShipmentButtonWrapper>
                            <SaveShipmentButton
                              country={country}
                              trackEvent={trackEvent}
                              saveData={shareDataObject}
                              isBusiness={isBusiness}
                              onSuccessSaveHandler={this.onSuccessSaveHandler}
                              stepperEnabled={stepperEnabled}
                            />
                          </SaveShipmentButtonWrapper>
                        </OfferFilterWrapper>
                        {this.renderOffers()}
                      </React.Fragment>
                    )}
                    {this.areOffersEmpty() && (
                      <EmptyOffers
                        copyNamespace={SS}
                        haveTheBackendsErrors={haveTheBackendsErrors}
                        backToShipmentLaneReference={
                          backToShipmentLaneReference
                        }
                        trackEvent={trackEvent}
                        dataTracking={this.frequentShipmentLink}
                      />
                    )}

                    {enableTeaserOverlayFeature && (
                      <TeaserOverlay
                        buttonText={this.getCopy(
                          "regularShiptmentTeaserButton"
                        )}
                        headlineText={this.getCopy(
                          "regularShiptmentTeaserHeadline"
                        )}
                        copyText={this.getCopy("regularShiptmentTeaserCopy")}
                        spotShipmentTabReference={spotShipmentTabReference}
                        trackEvent={trackEvent}
                        toggleRegularShipmentTeaser={
                          toggleRegularShipmentTeaser
                        }
                      />
                    )}
                    {!this.areOffersEmpty() && (
                      <VisitLaterActionsWrapper className="grid-maxWidthInner">
                        <ShareButton
                          intl={intl}
                          dataTestid="share-quotes"
                          dataTracking={this.shareQuotesClickedTrackingKeyPath}
                          trackEvent={trackEvent}
                          trackingValue={{ shareQuotesClicked: true }}
                          shareUrl={shareUrl}
                          utfDataObject={{
                            name: UTF_EVENT_CONTENT_NAMES.EMAIL_QUOTES,
                            type: UTF_EVENT_TYPES.BUTTON,
                            interaction: UTF_EVENT_INTERACTIONS.CLICK,
                            position: UTF_EVENT_CONTENT_POSITION.PRODUCT_LANE,
                            context: isBusiness
                              ? SEGMENT_TYPES.business
                              : SEGMENT_TYPES.private,
                          }}
                        />
                        <CopyQuoteLinkButton
                          trackEvent={trackEvent}
                          dataTracking={
                            this.shareQuotesFallbackClickedTrackingKeyPath
                          }
                          trackingValue={{ shareQuotesFallbackClicked: true }}
                          intl={intl}
                          shareUrl={shareUrl}
                          utfDataObject={{
                            name: UTF_EVENT_CONTENT_NAMES.COPY_LINK,
                            type: UTF_EVENT_TYPES.BUTTON,
                            interaction: UTF_EVENT_INTERACTIONS.CLICK,
                            position: UTF_EVENT_CONTENT_POSITION.PRODUCT_LANE,
                            context: isBusiness
                              ? SEGMENT_TYPES.business
                              : SEGMENT_TYPES.private,
                          }}
                        />
                        <ResponsiveRender
                          match="tablet"
                          render={(isTablet) =>
                            !isTablet && (
                              <div>
                                <PrintButton
                                  dataTestid="download-quotes"
                                  dataTracking={
                                    this.downloadQuotesClickedTrackingKeyPath
                                  }
                                  trackEvent={trackEvent}
                                  trackingValue={{
                                    downloadQuotesClicked: true,
                                  }}
                                  utfDataObject={{
                                    name: UTF_EVENT_CONTENT_NAMES.PRINT_QUOTES,
                                    type: UTF_EVENT_TYPES.BUTTON,
                                    interaction: UTF_EVENT_INTERACTIONS.CLICK,
                                    position:
                                      UTF_EVENT_CONTENT_POSITION.PRODUCT_LANE,
                                    context: isBusiness
                                      ? SEGMENT_TYPES.business
                                      : SEGMENT_TYPES.private,
                                  }}
                                />
                              </div>
                            )
                          }
                        />
                      </VisitLaterActionsWrapper>
                    )}
                  </OfferLaneWrapper>
                )}
                {!isLoadingIndicatorVisible && !this.areOffersEmpty() && (
                  <Disclaimer role="article" className="grid-maxWidth">
                    <DhlText
                      size={Sizes.SM}
                      ariaLabel={this.getCopy(
                        "screenReaderLabel_priceDisclaimerCopy"
                      )}
                      isParagraph
                    >
                      <span aria-hidden="true">*&nbsp;</span>
                      {this.getCopy("priceDisclaimerCopy", {
                        br: <br key="key" />,
                      })}
                    </DhlText>
                    <PrintDisclaimerWrapper>
                      <DhlText size={Sizes.SM} isParagraph>
                        {this.getCopy("printDisclaimerTerms", {
                          DOMAIN_NAME: domain.name,
                        })}
                      </DhlText>

                      <DhlText size={Sizes.SM} isParagraph>
                        {this.getCopy("printDisclaimerPrivacy", {
                          DOMAIN_NAME: domain.name,
                        })}
                      </DhlText>
                    </PrintDisclaimerWrapper>
                  </Disclaimer>
                )}
              </div>
            </OffersSectionWrapper>
            {stepperEnabled && (
              <BackButtonWrapper stepperEnabled={stepperEnabled}>
                <CustomBackButton onClick={() => hasBackButtonClicked()}>
                  <StyledIconWrapper>
                    <Icon useAs="decorative" icon={arrowBack} />
                  </StyledIconWrapper>
                  {this.getCopy("back", undefined, COPY_ID_PREFIX_NAVIGATION)}
                </CustomBackButton>
              </BackButtonWrapper>
            )}
          </React.Fragment>
        )}

        {isModalErrorVisible && (
          <ModalError
            onClose={toggleModalError}
            isOpen={isModalErrorVisible}
            onRetry={retrySubmitAction}
            isRetrying={isWaitingForResponse}
            headlineString={intl.formatMessage({
              id: "SS.ModalError.headline",
            })}
            sublineString={intl.formatMessage({
              id: "SS.ModalError.subHeadline",
            })}
            bodyContentString={intl.formatMessage({ id: "SS.ModalError.copy" })}
            retryButtonLabel={intl.formatMessage({ id: "SS.ModalError.retry" })}
            cancelButtonLabel={intl.formatMessage({
              id: "SS.ModalError.cancel",
            })}
            closeButtonLabel={intl.formatMessage({
              id: "SS.ContentModal.close",
            })}
          />
        )}
        {isModalSuccessVisible && (
          <ModalSuccess
            intl={intl}
            onClose={toggleModalSuccess}
            isOpen={isModalSuccessVisible}
          />
        )}
        {isModalExpressVisible && (
          <this.ModalExpressWithCountry
            intl={intl}
            onClose={toggleModalExpress}
            isOpen={isModalExpressVisible}
            iNeedTheseProps={["showModalExpressPhoneCta"]}
            utfDataObject={{
              conversion: {
                name: UTF_EVENT_CONVERSION_NAMES.BOOKING_INTENT,
                type: UTF_EVENT_CONVERSION_TYPES.HANDOVER,
                detail: UTF_EVENT_CONVERSION_DETAIL.EXPRESS_CTA,
              },
              content: {
                name: UTF_EVENT_CONTENT_NAMES.MOBILE_BOOKING_MODAL,
                type: UTF_EVENT_TYPES.MODAL,
                interaction: UTF_EVENT_INTERACTIONS.LOAD,
                position: UTF_EVENT_CONTENT_POSITION.PRODUCT_CARD,
                context: isBusiness
                  ? SEGMENT_TYPES.business
                  : SEGMENT_TYPES.private,
              },
            }}
          />
        )}
        {isModalBookingNotAllowedVisible && (
          <BookingNotAllowed
            intl={intl}
            onClose={toggleBookingNotAllowedModal}
            isOpen={isModalBookingNotAllowedVisible}
          />
        )}
        {isModalFreightP2PVisible && (
          <this.ModalFreightP2PWithCountry
            isOpen={isModalFreightP2PVisible}
            onClose={this.closeFreightP2PModal}
            validateFreightP2PModalFormFields={
              validateFreightP2PModalFormFields
            }
            onFreightP2PModalInformationChange={
              this.onFreightP2PModalInformationChange
            }
            getFreightP2PModalRequestSent={getFreightP2PModalRequestSent}
            offerData={modalFreightP2POfferData}
            isFormValid={isFormValid}
            isWaitingForResponse={isWaitingForFreightModalResponse}
            showCurrencyIsoCodeForPrices={showCurrencyIsoCodeForPrices}
            closeButtonDataTracking={
              this.freightP2PModalCloseButtonTrackingKeyPath
            }
            iNeedTheseProps={[
              "nativeLanguageCode",
              "formatCurrencyWithNativeLocale",
            ]}
            isBusiness={isBusiness}
          />
        )}
      </React.Fragment>
    );
  }
}

export default injectIntl(OffersLaneComponent);
